import { render, staticRenderFns } from "./Pillar5.vue?vue&type=template&id=48b8df4b&"
import script from "./Pillar5.vue?vue&type=script&lang=js&"
export * from "./Pillar5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports